import ShareHolderReturns from './ShareHolderReturns';

export default ShareHolderReturns;
